import { SVGProps } from 'react';

const Radius = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20.34 17.52a10 10 0 1 0-2.82 2.82m-4.11-6.93 4.18 4.18M21 19a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-7-7a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
    />
  </svg>
);
export default Radius;
